<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-07-13
-->

<script lang="ts" setup>
// Section 4 — Video Course
// Reference: 4. HOME.png
// Layout: white bg, centered title, 3-col card grid
// Each card: light gray rounded container, image top, bold Khmer title, bullet list

import { computed } from 'vue';
import imgCourse1 from '~/assets/images/video-course01.hero.png';
import imgCourse2 from '~/assets/images/video-course02.hero.jpg';
import imgCourse3 from '~/assets/images/video-course03.hero.jpg';

const { t } = useI18n();

const courses = computed(() => [
  {
    id: 1,
    img: imgCourse1,
    title: t('videoCourse.general.title'),
    items: [
      t('videoCourse.general.items.0'),
      t('videoCourse.general.items.1'),
      t('videoCourse.general.items.2'),
      t('videoCourse.general.items.3'),
    ],
  },
  {
    id: 2,
    img: imgCourse2,
    title: t('videoCourse.languages.title'),
    items: [
      t('videoCourse.languages.items.0'),
      t('videoCourse.languages.items.1'),
      t('videoCourse.languages.items.2'),
      t('videoCourse.languages.items.3'),
    ],
  },
  {
    id: 3,
    img: imgCourse3,
    title: t('videoCourse.skills.title'),
    items: [
      t('videoCourse.skills.items.0'),
      t('videoCourse.skills.items.1'),
      t('videoCourse.skills.items.2'),
      t('videoCourse.skills.items.3'),
    ],
  },
]);
</script>

<template>
  <section id="video" class="w-full bg-white">
    <div class="mx-auto max-w-360 px-6 py-16 md:px-20">
      <!-- Title -->
      <h2 class="mb-12 text-center text-[26px] font-extrabold text-gray-900 sm:text-[32px] md:text-[36px]">
        {{ t('videoCourse.title') }}
      </h2>

      <!-- 3-col card grid -->
      <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <div v-for="course in courses" :key="course.id" class="flex flex-col rounded-[26px] bg-bg-gray p-5 shadow-sm">
          <!-- Course image — padded inside card with rounded corners -->
          <div class="h-55 w-full overflow-hidden rounded-[18px]">
            <AppImage
              :src="course.img"
              :alt="course.title"
              img-class="h-full w-full rounded-[18px] object-cover animate-fade-in"
              loader-size="h-10 w-10"
              loader-overlay-class="bg-slate-100"
            />
          </div>

          <!-- Card body -->
          <div class="flex flex-col px-1 pt-6 pb-2">
            <!-- Course title -->
            <h3 class="pb-2 text-[24px] leading-tight font-extrabold text-gray-900">
              {{ course.title }}
            </h3>

            <!-- Bullet list -->
            <ul class="mt-5 space-y-3.5">
              <li
                v-for="item in course.items"
                :key="item"
                class="flex items-start gap-2.5 text-[15px] font-medium text-gray-900"
              >
                <span class="mt-0.5 shrink-0 text-[18px] leading-none font-extrabold text-black">•</span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
